import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import moment from "moment";

import Header from "../Include/Header";
import Sidebar from "../Include/Sidebar";
import Footer from "../Include/Footer";
import Loader from "../Include/Loader";
import { Pagination, Search } from "../Table";
import DropDown from "../../../Components/DropDown";

import { getAdminPurchaseOrders } from "../../../Store/Admin/believe/purchaseOrder/GetPo";
import { deleteAdminPurchaseOrder } from "../../../Store/Admin/believe/purchaseOrder/DeletePo";
import { downloadAdminPurchaseOrderPdf } from "../../../Store/Admin/believe/purchaseOrder/DownloadPo";

const PurchaseOrderList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setlimit] = useState(10);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    dispatch(getAdminPurchaseOrders({}));
  }, [dispatch]);

  const { data: poResponse, loading } = useSelector(
    (state) => state?.getAdminPurchaseOrders || {}
  );

  const commentsData = useMemo(() => {
    let computedComments = poResponse?.data || [];

    if (search) {
      const q = search.toLowerCase();
      computedComments = computedComments?.filter(
        (elem) =>
          elem.po_no?.toLowerCase()?.includes(q) ||
          elem.vendor_snapshot?.name?.toLowerCase()?.includes(q) ||
          elem.order_details?.project_name?.toLowerCase()?.includes(q)
      );
    }
    setTotalItems(computedComments?.length || 0);
    return computedComments?.slice(
      (currentPage - 1) * limit,
      (currentPage - 1) * limit + limit
    );
  }, [currentPage, search, limit, poResponse?.data]);

  const handleDelete = (id, title) => {
    Swal.fire({
      title: `Are you sure want to delete ${title}?`,
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteAdminPurchaseOrder(id)).then((response) => {
          const { message, success } = response?.payload || {};
          if (success) {
            toast.success(message || "Deleted successfully");
            dispatch(getAdminPurchaseOrders({}));
          }
        });
      }
    });
  };

  const handleRefresh = () => {
    setSearch("");
    dispatch(getAdminPurchaseOrders({}));
  };

  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleDownloadPO = (id) => {
    dispatch(downloadAdminPurchaseOrderPdf(id)).then((response) => {
      const { success, message, data } = response?.payload || {};
      if (success && data?.url) {
        window.open(data.url, "_blank");
        toast.success(message || "PO Downloaded successfully");
      } else {
        toast.error(message || "Failed to download PO");
      }
    });
  };

  return (
    <>
      <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
        <Header handleOpen={handleOpen} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/admin/dashboard">Dashboard </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <i className="feather-chevron-right"></i>
                    </li>
                    <li className="breadcrumb-item active">Purchase Order List</li>
                  </ul>
                </div>
              </div>
            </div>

            {loading === false ? (
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-table show-entire">
                    <div className="card-body">
                      <div className="page-table-header mb-2">
                        <div className="row align-items-center">
                          <div className="col">
                            <div className="doctor-table-blk">
                              <h3>Purchase Order List</h3>
                              <div className="doctor-search-blk">
                                <div className="top-nav-search table-search-blk">
                                  <form onSubmit={(e) => e.preventDefault()}>
                                    <Search
                                      onSearch={(value) => {
                                        setSearch(value);
                                        setCurrentPage(1);
                                      }}
                                    />
                                    {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                    <a className="btn">
                                      <img
                                        src="/assets/img/icons/search-normal.svg"
                                        alt="search"
                                      />
                                    </a>
                                  </form>
                                </div>
                                <div className="add-group">
                                  <Link
                                    to="/admin/manage-purchase-order"
                                    className="btn btn-primary add-pluss ms-2"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Add"
                                  >
                                    <img
                                      src="/assets/img/icons/plus.svg"
                                      alt="plus-icon"
                                    />
                                  </Link>
                                  <button
                                    type="button"
                                    onClick={handleRefresh}
                                    className="btn btn-primary doctor-refresh ms-2"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Refresh"
                                  >
                                    <img
                                      src="/assets/img/icons/re-fresh.svg"
                                      alt="refresh"
                                    />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                            <DropDown
                              limit={limit}
                              onLimitChange={(val) => setlimit(val)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="table-responsive">
                        <table className="table border-0 custom-table comman-table mb-0 datatable">
                          <thead>
                            <tr>
                              <th>Sr.</th>
                              <th>Order Date</th>
                              <th>PO No.</th>
                              <th>Party Name</th>
                              <th>Project</th>
                              {/* <th>Total Weight</th> */}
                              <th>Total Amount</th>
                              <th className="text-end">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {commentsData?.length === 0 ? (
                              <tr>
                                <td colSpan="8" className="text-center py-4">
                                  No Purchase Orders found
                                </td>
                              </tr>
                            ) : (
                              commentsData?.map((elem, i) => (
                                <tr key={elem?._id}>
                                  <td>{(currentPage - 1) * limit + i + 1}</td>
                                  <td>
                                    {elem?.po_date
                                      ? moment(elem.po_date).format("DD-MM-YYYY")
                                      : "-"}
                                  </td>
                                  <td>{elem?.po_no}</td>
                                  <td>{elem?.vendor_snapshot?.name || "-"}</td>
                                  <td>{elem?.order_details?.project_name || "-"}</td>
                                  {/* <td>
                                    {Number(elem?.total_weight || 0).toFixed(2)}{" "}
                                  </td> */}
                                  <td>
                                    {Number(elem?.grand_total || elem?.subtotal || 0).toFixed(2)}
                                  </td>

                                  <td className="text-end">
                                    <div className="dropdown dropdown-action">
                                      <a
                                        href="#"
                                        className="action-icon dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                        aria-expanded="false"
                                      >
                                        <i className="fa fa-ellipsis-v"></i>
                                      </a>
                                      <div className="dropdown-menu dropdown-menu-end">
                                        <button
                                          type="button"
                                          className="dropdown-item"
                                          onClick={() =>
                                            navigate("/admin/manage-purchase-order", {
                                              state: elem,
                                            })
                                          }
                                        >
                                          <i className="fa-solid fa-pen-to-square m-r-5"></i>{" "}
                                          Edit
                                        </button>
                                        <button
                                          type="button"
                                          className="dropdown-item"
                                          onClick={() =>
                                            handleDelete(elem?._id, elem.po_no)
                                          }
                                        >
                                          <i className="fa fa-trash-alt m-r-5"></i>{" "}
                                          Delete
                                        </button>
                                        <button
                                          type="button"
                                          className="dropdown-item"
                                          onClick={() =>
                                            handleDownloadPO(elem?._id)
                                          }
                                        >
                                          <i className="fa fa-download m-r-5"></i>{" "}
                                          Download PO
                                        </button>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                      <div className="row align-center mt-3 mb-2">
                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                          <div
                            className="dataTables_info"
                            id="DataTables_Table_0_info"
                            role="status"
                            aria-live="polite"
                          >
                            Showing {Math.min(limit, totalItems)} from{" "}
                            {totalItems} data
                          </div>
                        </div>
                        <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                          <div
                            className="dataTables_paginate paging_simple_numbers"
                            id="DataTables_Table_0_paginate"
                          >
                            <Pagination
                              total={totalItems}
                              itemsPerPage={limit}
                              currentPage={currentPage}
                              onPageChange={(page) => setCurrentPage(page)}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <Loader />
            )}
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default PurchaseOrderList;
